module.exports = __webpack_public_path__ + "static/media/mistmaker_on.dbd79891.gif";